module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('b', [_vm._v("CHAPTER TWO")])])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("A JOYFUL JOURNEY TO A SPIRITUAL GIFT")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-002_1",
      "src": "images/dingbat_grapes_gray.jpg"
    }
  })])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("God brings forth wine to gladden the human heart.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM 104:15 (AUTHOR’S PARAPHRASE)")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("S")]), _vm._v("ince ancient times people have understood wine as a mediator between heaven and earth, the sacred and the secular, the extraordinary and the ordinary, and even a place of revelation. And yet it still comes as a surprise to many that wine should have played such an important role in people’s spiritual experiences, especially in the Jewish and Christian faith traditions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This amnesia is a heartrending loss because the Bible is saturated with talk about wine. It’s the most talked about food, and there are "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("nearly a thousand references to wine and wine-related themes in these sacred Scriptures. The psalmist writes that God “bring[s] forth food from the earth, and wine to gladden the human heart” (Psalm 104:14-15). That’s an astonishing pronouncement.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We are supposed to take pleasure in wine and lean into a life of joy as part of our spiritual journey? Yes, that is what it says.")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_c('i', [_vm._v("“Wine drunk at the proper time brings joy, cheerfulness and conviviality.”")])])]), _c('div', {
    staticClass: "lettre_source"
  }, [_c('b', [_c('i', [_vm._v("BEN SIRA (C. 200 BC),"), _c('br'), _vm._v("JEWISH WISDOM TEACHER")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We all know that joy and gladness are hard to come by in our world, and to reject the gifts of God that are to bring us joy seems like a "), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("deeply flawed approach to the spiritual life. We are in desperate need of more joy in our world, so why abandon one of the most wonderful and delicious gifts from God? It doesn’t really make sense, does it?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Have you ever wondered why we don’t hear much about what Jesus would eat and drink or how much Jesus enjoyed his regular cup of wine? Did you know that he enjoyed wine, food, and dinner parties so much that his fellow Jews accused him of being a glutton and a drunkard? I guess we don’t talk about this part of Jesus’ life much because we don’t think it’s that important. Or perhaps it doesn’t fit into our picture of who Jesus was, and so we quietly pass over these seemingly unimportant, unnecessary, and perhaps even embarrassing details.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Usually, we hear about what Jesus said and did—the miracles he performed and what others have written about what he said and did. From that we are supposed to know what we should say and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("do. Most of the teaching I’ve heard settles on the moral level. It’s about right and wrong, good and bad, what we ought to do and how we ought to behave.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("When we come to passages in Scripture that can’t be pulled down to that level, we tend to pass them by. They’re just pure ornamentation. Protestants like me certainly have done that with Jesus’ transfiguration. It’s an unusual story for sure. It’s a story of pure bliss and beauty and revelation without immediate moral implications. Orthodox Christians devote a whole day to celebrate Jesus’ transfiguration and meditate on it extensively through their icons and art. We Protestants tend to ignore it—at least this is my experience. It seems that when we can’t draw a moral from a story, we don’t know what to do with it.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("WINE RULES")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Perhaps the only thing you have heard about wine is that it is dangerous—or worse, that wine is bad and that you should steer away from it. In Christian circles we’ve often reduced the subject of wine to questions of good and bad. More recently, the “wine experts” have made knowing about wine highly competitive and exclusive. Talk about wine has become so convoluted that it feels to many of us like an impenetrable maze. No wonder that too many still have ambivalent feelings about wine. Some still wonder, "), _c('i', [_vm._v("Is it right or wrong to drink wine? Wouldn’t it be better if all abstained?")]), _vm._v(" Others might think, "), _c('i', [_vm._v("The wine world is by far too complicated, sophisticated, and elitist for me")]), _vm._v("—and they conclude that wine is just not for them. That’s unfortunate because wine is supposed to be for everyone.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("The other day I went to get a wine glass out of the cabinet to have a small glass of wine while I wrapped up a long writing day. It was just before six p.m., and my friend Noranne saw me get the wine glass and said, “Oh, you naughty girl!” We both laughed, but there was this underlying sense that I was doing something forbidden. I don’t think many church cultures are at all clear about how they feel about wine, and there are still too many unspoken prejudices and rules against it.")])])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('b', [_c('i', [_vm._v("Our relationship with wine is far from being healed and restored.")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Our relationship with wine is far from being healed and restored. The most outrageous sermon I have heard about the wedding feast of Cana was when a Baptist theologian preached on it and argued that the wine really didn’t matter at all in the story. What did matter was that Jesus revealed his sovereign power. I looked around the room and saw all these eager students take in this misreading of the text. They seemed to swallow it hook, line, and sinker. It made me sad and angry.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Why are we so obsessed with Jesus’ power and sovereignty that we forget to notice beauty and deny ourselves his extravagant generosity? I found, and still find, all this quite puzzling.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("PILGRIMS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Benedictine nuns began planting vines and crafting wine in the region where my family lives as early as the sixth century. They believed that wine was a gift from God and inseparable from the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("good news they were bringing to these wild and unruly barbarian tribes of Europe. After all, they needed wine for the celebration of the Eucharist. We have fourteen hundred years of unbroken belief in the goodness of the earth, the soil, and of course wine as part of our spiritual heritage.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Everything we did as a family had to do with the sun and the rain, heat and cold, water and soil, digging into the earth and planting vines, harvesting grapes and watching this amazing miracle of grape juice slowly but surely turning into wine. Smells of organic soil, fermenting grape juice, and fragrant wine have haunted me all my life long. These smells are impressed on my imagination, and the memories are vivid and make me feel glad—even giddy. I grew up with a fundamental sense that this earth is good and that wine is a special gift from God to bring us joy and deepen our experience of joy.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Year in and year out my family has been concerned with—or perhaps it’s more honest to say obsessed over—this one thing: to craft wine and hope that it will bring joy and conviviality to our customers. We all knew that this joy is not just ours to grasp but is something that we need to cultivate and protect for generations yet to be born. My dad, who isn’t a very religious person, would turn into a religious zealot whenever it came to the earth and the soil and our responsibility to take care of it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("People come and go every day from far and near to our tasting room to sample wine. But they don’t just come to sample wine. While their mouths and noses are attuned to sniff and smell, to taste and savor, they also want to talk. They linger. Our tasting room invites people to stay for a little while.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("Often our customers want to talk about the wine but also about the vineyards, the soil, the weather, the new vintage, and the struggles and joys we had in crafting it. They also ask about our family, and we ask about their families. We have known many of our customers for a long time. Beyond the tasting and savoring, the getting and spending, there is perhaps something else people are searching for.")])])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('b', [_c('i', [_vm._v("“A book of Verses underneath the Bough, A Jug of Wine, a Loaf of Bread—and Thou Beside me singing in the Wilderness—Oh, Wilderness were Paradise now!”")])])])]), _c('div', {
    staticClass: "lettre_source"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('b', [_c('i', [_vm._v("OMAR KHAYYAM"), _c('br'), _vm._v(" (1048–1131), PERSIAN POET AND PHILOSOPHER")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Though pilgrimages have come back into fashion again, most people I know go on holidays to recover from their stressful lives in the city. Wineries and tasting rooms have increasingly become holiday destinations. Many of our customers are on vacation. You might wonder why that is.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("What are people looking for when they go to a winery? Can’t they just pick up a bottle of wine at the supermarket and save themselves all the trouble of traveling to wineries and tasting rooms? What is it about these places that draws us into their spell?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I’ve watched this enchantment all my life, and I have often wondered about it. Something about wine has captured the imagination of people throughout the ages. Somehow wine casts a spell on those who are open and receptive to its wondrous and mysterious allures.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I believe that wine has such a spell on people because it is a unique gift that opens our lives to greater and more mysterious "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("realities. It hints at splendors and beauty and joy we often don’t notice in the hustle and bustle of our daily lives. For those who see with eyes of faith, wine becomes a spiritual gift, imbued with spiritual meaning. Wine was never meant to be just another beverage. In the Bible wine’s role is to open our lives to the Giver of all good things, God himself. The beauty and complexity of wine hints at a reality much greater than what our eyes can see, our hands can touch, our tongues can taste, and our noses can smell. Wine hints at the unfathomable generosity of our Creator, who invites us into his presence to linger and to be filled with his love and grace and joy.")])])])])])])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 69
// module chunks = 0